// Evaluates one body's truncated VSOP87A series (layout in vsop87data.js) with
// no data attached, so a page that needs only the Earth (vsop87earth.js) can
// carry its 13 KB instead of every planet's.

// T: Julian millennia of TDB (TT, within 2 ms) from J2000.
export function vsopSeries(series, jdTT, out = [0, 0, 0]) {
  const T = (jdTT - 2451545.0) / 365250;
  for (let v = 0; v < 3; v++) {
    let sum = 0, tp = 1;
    const byAlpha = series[v];
    for (let a = 0; a < byAlpha.length; a++) {
      const f = byAlpha[a];
      let s = 0;
      for (let k = 0; k < f.length; k += 3) s += f[k] * Math.cos(f[k + 1] + f[k + 2] * T);
      sum += s * tp;
      tp *= T;
    }
    out[v] = sum;
  }
  return out;
}
